// extracted by mini-css-extract-plugin
export default {"NewWorksetDialog":"NewWorksetDialog_NewWorksetDialog__AUZCt"};